import React, { Suspense, lazy, } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom"; // new import
import './App.scss';
const E404 = lazy(() => import("./components/e404/e404.js"));
const Home = lazy(() => import("./views/home/home.js"));
// const Comics = lazy(() => import("./views/comics/comics.js"));
const Comics = lazy(() => import("./views/comics_v1/comics_v1.js"));
// const Super = lazy(() => import("./views/cv_super/super.js"));
// const Console = lazy(() => import("./views/cv_console/console.js"));
// const Brex = lazy(() => import("./views/cv_brex/brex.js"));
// const RecRoom = lazy(() => import("./views/cv_recroom/recroom.js"));
// const Prezo = lazy(() => import("./views/cv_prezo/prezo.js"));
// const REPLICANT = lazy(() => import("./views/cv_replicant/replicant.js"));
// const PALADIN = lazy(() => import("./views/cv_paladin/paladin.js"));
// const AIZTECH = lazy(() => import("./views/cv_aiztech/aiztech.js"));

export default function App() {

    return (
        < BrowserRouter >
            <Suspense fallback={<div></div>}>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/comics" element={<Comics />} />
                    {/* <Route path="/brex" element={<Brex />} />
                    <Route path="/super" element={<Super />} />
                    <Route path="/console" element={<Console />} />
                    <Route path="/recroom" element={<RecRoom />} />
                    <Route path="/prezo" element={<Prezo />} />
                    <Route path="/replicant" element={<REPLICANT />} />
                    <Route path="/paladin" element={<PALADIN />} />
                    <Route path="/aiztech" element={<AIZTECH />} /> */}
                    <Route path="*" element={<E404 />} />
                </Routes>
            </Suspense>
        </BrowserRouter >
    );
}


